import { render, staticRenderFns } from "./CmDeliveryNoteNumber.vue?vue&type=template&id=4be31380&"
import script from "./CmDeliveryNoteNumber.vue?vue&type=script&lang=js&"
export * from "./CmDeliveryNoteNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports